import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

const arrowHeight = 10;
const arrowWidth = 2 * arrowHeight;

export const Styles = StyleSheet.create({
  container: {
    shadowColor: 'black',
    shadowRadius: 50,
    shadowOpacity: 0.25,
    borderRadius: grid(1),
    maxHeight: 400,
    maxWidth: 360,
    overflow: 'hidden',
  },
  themeWhite: { backgroundColor: 'white' },
  themeDark: { backgroundColor: 'rgba(0,0,0,0.7)' },
  themePurple: { backgroundColor: Colors.v2.purple },
  arrow: {
    width: 0,
    height: 0,
    borderLeftWidth: arrowWidth / 2,
    borderRightWidth: arrowWidth / 2,
    borderStyle: 'solid',
    backgroundColor: 'transparent',
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    marginHorizontal: arrowWidth / 4,
    // make the tooltip appear over the container
    // so that it is unaffected by its shadow.
    zIndex: 1,
  },
  arrowWhite: { borderColor: 'white' },
  arrowDark: { borderColor: 'rgba(0,0,0,0.7)' },
  arrowPurple: { borderColor: Colors.v2.purple },
  arrowUp: { borderBottomWidth: arrowHeight },
  arrowDown: { borderTopWidth: arrowHeight },
  closeIcon: {
    padding: 0,
    width: 12,
    height: 12,
  },
});
